const showMarkets = (event) => {
  const target = event.target
  const container = target.closest(".market-selector")
  // const dropdown = container.querySelector(".market-selector--dropdown")
  container.classList.toggle("is-active")
}

// if (document.querySelector("#insta-feed-wall")) {
//   const instagramSlide = () => {
//     new Swiper(".instagram .swiper-container", {
//       loop: true,
//       autoplay: {
//         delay: 1,
//         disableOnInteraction: false,
//       },
//       speed: 3500,
//       slidesPerView: "auto",
//       freeMode: true,
//       spaceBetween: 10,
//       watchOverflow: true,
//       allowTouchMove: false,
//       centerInsufficientSlides: true,
//     })
//   }

//   const instagramFeedWall = new Instafeed({
//     accessToken:
//       "IGQVJYTlhDNTBlamlPTU5FMXp2b1llLWFBLVIwT1ZANY2hHSEtIX2dUZAXYxNnJjbHY1eGw0MGdiRVFKZA0xlb0UzTHFtd05wRlpIUWtuclVNaHpvSzRwbVZAuTF9SQXBURl9FZA1F3U01Xa2trX09vZAlMwXwZDZD",
//     limit: 13,
//     target: "insta-feed-wall",
//     template:
//       '<a target="_blank" aria-label="IG Image" class="swiper-slide insta-post" href="{{link}}"><img class="w-100 lazyload" alt="" data-src="{{image}}" /></a>',
//     success: function () {
//       setTimeout(() => {
//         instagramSlide()
//       }, 500)
//     },
//   })

//   instagramFeedWall.run()
// }

const toggleClassEl = (selector, className) => {
  const el = document.querySelector(selector)
  el.classList.toggle(className)
}

const handleQuantity = (type, inputSelector) => {
  const input = document.querySelector(inputSelector)
  if (!input) return

  const container = input.parentNode
  const text = container.querySelector("h3")

  let state = parseInt(input.value)
  if (type === "plus") state++
  if (type === "minus" && state > 1) state--

  input.value = state
  if (text) text.innerText = state
}

document.addEventListener("DOMContentLoaded", function () {
  const script = document.createElement("script")
  script.src = "//www.klaviyo.com/media/js/public/klaviyo_subscribe.js"
  script.type = "text/javascript"
  document.body.appendChild(script)

  setTimeout(() => {
    try {
      KlaviyoSubscribe.attachToForms("#newsletter-footer", {
        hide_form_on_success: true,
        custom_success_message: true,
        success_message: "Thanks for subscribe!!",
        extra_properties: {
          $source: "webfooter",
        },
      })
    } catch (e) {
      console.error(e)
    }
  }, 1000)
  ;(function () {
    var s = document.createElement("script")
    var h = document.querySelector("head") || document.body
    s.src = "https://acsbapp.com/apps/app/dist/js/app.js"
    s.async = true
    s.onload = function () {
      acsbJS.init({
        statementLink: "",
        footerHtml: "",
        hideMobile: false,
        hideTrigger: true,
        disableBgProcess: false,
        language: "en",
        position: "left",
        leadColor: "#146ff8",
        triggerColor: "#146ff8",
        triggerRadius: "50%",
        triggerPositionX: "right",
        triggerPositionY: "bottom",
        triggerIcon: "people",
        triggerSize: "medium",
        triggerOffsetX: 20,
        triggerOffsetY: 20,
        mobile: {
          triggerSize: "small",
          triggerPositionX: "right",
          triggerPositionY: "bottom",
          triggerOffsetX: 10,
          triggerOffsetY: 10,
          triggerRadius: "50%",
        },
      })
    }
    h.appendChild(s)
  })()

  function okeStarsFilters() {
    const okeReviews = document.querySelector(".oke-w-reviews-head")
    const okeRating = document.querySelectorAll(
      ".oke-w-breakdownModule-distribution-label"
    )
    okeRating.forEach((el) => {
      el.addEventListener("click", () => {
        const ratingNumber = el.querySelector(
          ".oke-w-breakdownModule-distribution-label-number"
        ).innerText
        const inputRating = document.querySelector(
          `input[name='Rating ${ratingNumber}'] + label`
        )
        inputRating.click()
        okeReviews.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "start",
        })
      })
    })
  }
  const interval = setInterval(() => {
    if (
      document.querySelectorAll(".oke-w-breakdownModule-distribution-label")
        .length > 6
    ) {
      okeStarsFilters()
      clearInterval(interval)
    }
  }, 500)
  setTimeout(() => {
    clearInterval(interval)
  }, 10000)
})

document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver((mutations, obs) => {
    const btnCookies = document.querySelector("a[aria-label='allow cookies']")
    if (btnCookies) {
      btnCookies.addEventListener("click", () => {
        window.clarity("consent")
      })
      obs.disconnect() // Detenemos la observación una vez encontrado.
    }
  })
  observer.observe(document.body, { childList: true, subtree: true })
})

//Wizybot
// document.addEventListener("DOMContentLoaded", () => {
//   const productBtn = document.querySelector(".product_btn")
//   if (productBtn) {
//     scrollWizyBot(productBtn)
//     window.addEventListener("scroll", () => {
//       scrollWizyBot(productBtn)
//     })
//   }
// })

// const scrollWizyBot = (productBtn) => {
//   const isVisible = productBtn.getBoundingClientRect().top >= 0
//   const wizybotElement = document.querySelector("div#wizydiv iframe")
//   let distanceWizy = "15px"

//   if (window.innerWidth <= 1023 && wizybotElement) {
//     if (!isVisible) {
//       distanceWizy = "90px"
//       wizybotElement.style.bottom = distanceWizy
//     } else {
//       wizybotElement.style.bottom = distanceWizy
//     }
//   } else if (wizybotElement) {
//     wizybotElement.style.bottom = distanceWizy
//   }
// }

document.addEventListener('DOMContentLoaded', () => {
  const banner = document.querySelector('.custom__banner');
  const floatOke = document.querySelector('div[data-oke-loyalty-widget]');

  const observerOkendoWidget = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        floatOke?.classList.remove("is-active")
        } else {
        floatOke?.classList.add("is-active")
      }
    });
  });

  if (floatOke && banner) {
    observerOkendoWidget.observe(banner);
  } else if (floatOke) {
    floatOke?.classList.add("is-active")
  }
})